//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { list: [] } },
  created () {
    this.$ajax.get(this.$api.etTreeMembers + '?id=' + this.$route.query.id).then(r => { this.list = (r && r.list) || [] })
  },
  methods: {
    remove (m) {
      this.$ajax.post(this.$api.etTreeMemberRemove, { tree_id: this.$route.query.id, user_id: m.userId }).then(() => {
        this.list = this.list.filter(x => x.id !== m.id)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/members.vue